<template>
  <div id="mod-rm__trainerinformation">
    <div class="pkg-search-box">
      <el-form v-if="false">
        <el-form-item label="Vue-Gantt-Chart">
          <el-date-picker v-model="times"
                          size="small"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          style="width:300px">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-show="false"
                      label="cellHeight">
          <el-slider v-model="cellHeight"
                     :min="20"
                     :max="150"
                     style="width:60px"
                     size="small"></el-slider>
        </el-form-item>
        <el-form-item v-show="false"
                      label="cellWidth">
          <el-slider v-model="cellWidth"
                     :min="20"
                     :max="100"
                     style="width:60px"
                     size="small"></el-slider>
        </el-form-item>
        <el-form-item v-show="false"
                      label="scale">
          <el-select v-model="scale"
                     placeholder=""
                     style="width:80px"
                     size="small">
            <el-option v-for="item in scaleList"
                       :key="item"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="false">
          <el-checkbox v-model="hideHeader">hideHeader</el-checkbox>
        </el-form-item>
        <el-form-item v-show="false">
          <el-checkbox v-model="hideSecondGantt">hideSecondGantt</el-checkbox>
        </el-form-item>
      </el-form>
      <!-- <el-form :inline="true"
                 size="small"> -->
      <el-form label-position="left"
               class="pkg-content"
               :model="dataForm"
               @keyup.enter.native="getDataList()">
        <el-row>
          <!--培训师-->
          <el-col :span="7">
            <el-form-item :label="$t('trainer.trainer')"
                          class="search-item">
              <span slot="label">
                <el-link type="primary"
                         :underline="false"
                         slot="reference"
                         @click.native.prevent="showTrainerDlg">{{$t('trainer.trainer')}}</el-link>
              </span>
              <div class="el-input el-input--default el-input__inner"
                   style="height:30px;"
                   @mouseenter="trainerShow()"
                   @mouseleave="trainerLeave()">
                <div style="width:80%;float:left;"
                     class="holder"
                     contenteditable="false"
                     :placeholder="$t('cert.selectTips')">{{this.dataForm.trainerName}}</div>
                <el-link type="primary"
                         :underline="false"
                         class="el-icon-error link-delete-temp"
                         ref="trainerLink"
                         v-show="trainerShowFlg && dataForm.trainerName != '' && dataForm.trainerName != null"
                         style="float:right;margin-top:9px;color:rgba(0,0,0,.3);"
                         @click="trainerSeleteName()"></el-link>
              </div>
            </el-form-item>
          </el-col>
          <!--开始时间-->
          <el-col :span="7">
            <el-form-item :label="$t('registe.startdate')"
                          class="search-item"
                          prop="startDate"
                          :required="true">
              <el-date-picker v-model="dataForm.startDate"
                              :placeholder="$t('registe.startdate')"
                              type="date"
                              :editable="false"
                              :clearable="false"
                              :picker-options="pickerOptionsStart"
                              value-format="yyyy-MM-dd"
                              width="210" />
            </el-form-item>
          </el-col>
          <!--结束时间-->
          <el-col :span="7">
            <el-form-item :label="$t('registe.enddate')"
                          class="search-item"
                          prop="endDate"
                          :required="true">
              <el-date-picker v-model="dataForm.endDate"
                              :placeholder="$t('registe.enddate')"
                              type="date"
                              :editable="false"
                              :clearable="false"
                              :picker-options="pickerOptionsEnd"
                              value-format="yyyy-MM-dd 23:59:59"
                              width="210" />
            </el-form-item>
          </el-col>
          <!-- 查询 -->
          <el-col :span="3">
            <el-col :span="24">
              <el-button class="M-search"
                         style="margin-bottom: 7px"
                         type="primary"
                         v-if="$hasPermission('Trainer001')"
                         @click="getDataList">{{$t('course.query')}}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <!-- 第二行 -->
        <el-row>
          <!-- 组织类型 -->
          <el-col :span="7">
            <el-form-item prop="queryOrgType"
                          class="search-item"
                          :label="$t('trainer.orgType')">
              <el-select v-model="dataForm.queryOrgType"
                         @change=add
                         :placeholder="$t('res.vehinfo.select')"
                         clearable>
                <el-option v-for="(item,index) in neworgType"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!-- 所在城市 -->
            <el-form-item :label="$t('res.site.city')"
                          class="search-item"
                          prop="regionIds">
              <address-select :level="2"
                              v-model="dataForm.regionIds"
                              placeholder="请选择">
              </address-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!-- 品牌 -->
            <el-form-item :label="$t('couse.brand')"
                          class="search-item"
                          prop="courseBrand">
              <el-select v-model="brandQuery"
                         multiple
                         collapse-tags
                         :placeholder="$t('course.select')">
                <el-option v-for="(item,index) in courseBrandArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 重置 -->
          <el-col :span="3"
                  style="float: right">
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="again">{{$t('reset')}}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <div v-show="moreList">
          <el-row class="btnAdvancedSearch">
            <el-col :span="7">
              <!-- 培训师团队分类 -->
              <el-form-item prop="groupType"
                            class="search-item"
                            :label="$t('trainer.teamClassification')">
                <class-tree ref="classRef"
                            v-on:getSelectList="getSelectList"
                            v-on:clearTreeInfo="clearTreeInfo"
                            v-bind:listName="'trainser'"
                            v-bind:defaultProps="defaultProps"
                            v-bind:url="queryTreeUrl"
                            v-bind:isSelect=false></class-tree>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row>
        </el-row>
      </el-form>
      <el-row style="text-align: center; margin-bottom: 10px;">
        <el-col :span="24">
          <div class="show-or-hide-icon"
               v-bind:class="{ 'el-icon-arrow-up': moreList,
                                         'el-icon-arrow-down': !moreList }"
               @click="moreList = !moreList">&nbsp;{{ moreList ? $t('talentpool.packUp') : $t('talentpool.advancedSearch') }}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pkg-content">
      <div class="search">
        <!-- 导出 btnExport -->
        <el-button type="primary"
                   v-if="$hasPermission('Trainer002')"
                   @click="exportHandle()">
          {{ $t('export') }}
        </el-button>
        <!-- 导出明细-->
        <el-button type="primary"
                   v-if="$hasPermission('Trainer002')"
                   @click="exportinfo()">
          {{ $t('导出明细') }}
        </el-button>
      </div>
      <div>
        <span>
          日程表 &nbsp;&nbsp;| <label style="color:blue"
                 id='dayLable'
                 @click="queryDay()">日</label>&nbsp;&nbsp;| <label style="color:blue"
                 id='weekLable'
                 @click="queryWeek()">周</label>&nbsp;&nbsp;| <label style="color:blue"
                 id='monthLable'
                 @click="queryMonth()">月</label>
        </span>
      </div>
    </div>
    <div class="container">
      <!--   甘特图组件   -->
      <v-gantt-chart v-if="!hideSecondGantt"
                     v-loading="dataListLoading"
                     :startTime="times[0]"
                     :endTime="times[1]"
                     :tempStart="dataForm.startDate"
                     :cellWidth="cellWidth"
                     :cellHeight="cellHeight"
                     :timeLines="timeLines"
                     :titleHeight="titleHeight"
                     :scale="scale"
                     :titleWidth="titleWidth"
                     showCurrentTime
                     :hideHeader="hideHeader"
                     :dataKey="dataKey"
                     :arrayKeys="arrayKeys"
                     :scrollToPostion="positionB"
                     @scrollLeft="scrollLeftB"
                     customGenerateBlocks
                     :datas="datasB"
                     :queryType="queryType"
                     ref="gantChild"
                     :subHolidayList="holidayList">
        <template v-slot:block="{data,getPositonOffset,getWidthAbout2Times,isInRenderingTimeRange,startTimeOfRenderArea,endTimeOfRenderArea,isAcrossRenderingTimeRange}">
          <!--     渲染表格内容     -->
          <table-content :data="data"
                         :cellHeight="cellHeight"
                         :getPositonOffset="getPositonOffset"
                         :getWidthAbout2Times="getWidthAbout2Times"></table-content>
        </template>
        <template v-slot:left="{data}">
          <!--    表格左边（课程名称）      -->
          <LeftBarItem :data="data"></LeftBarItem>
        </template>
        <template v-slot:title>
          <div style="width:100%;">
            <div style="">培训师团队分类</div>
            <div style="width:50%;float:left;">培训师名称</div>
          </div>
        </template>
      </v-gantt-chart>
    </div>
    <div style="margin-top:15px">
      <span>培训师（主）:</span><span class="class1">&nbsp; &nbsp;&nbsp;&nbsp;</span>
      <span style="margin-left:27px">培训师（辅）:</span><span class="class3">&nbsp; &nbsp;&nbsp;&nbsp;</span>
      <span style="margin-left:27px">助教:</span><span class="class2">&nbsp; &nbsp;&nbsp;&nbsp;</span>
      <span style="margin-left:27px">参与者:</span><span class="class4">&nbsp; &nbsp;&nbsp;&nbsp;</span>
    </div>

    <!-- 培训师选择页面 -->
    <el-dialog title="培训师选择"
               :visible="isShowTrainer"
               width="95%"
               :before-close="handleClose">
      <trainer-element ref="trainerInfoRef"
                       @onOk="onOk"
                       @closeSuboTrainerDlg="closeSuboTrainerDlg"
                       v-bind:trainerList="trainerList"></trainer-element>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import vGanttChart from "./gantt/gantt.vue"
import LeftBarItem from "./left-bar-item/LeftBarItem.vue";
import TableContent from "./table-content/TableContent.vue";
import AddressSelect from '@/components/region-select'
import ClassTree from '@/components/rm/class-tree/index'
import ToggleDiv from '@/components/toggle-div'
import axios from 'axios'
import dayjs from "dayjs"
import trainerItem from '@/components/rm/trainer-select/index'
import { getLastDay, getDate, getFirstDay, GetMonday, GetSunday } from '@/utils/timeLineUtils.js'

const scaleList = `1,2,3,4,5,6,10,12,15,20,30,60,120,180,240,360,720,1440`
  .split(",")
  .map(n => parseInt(n, 10));
export default {
  // mixins: [mixinViewModule],
  name: "App",
  components: {
    LeftBarItem,
    'v-gantt-chart': vGanttChart,
    'class-tree': ClassTree,
    'trainer-element': trainerItem,
    TableContent,
    ToggleDiv,
    AddressSelect
  },
  data () {
    return {
      dataForm: {
        trainerName: '',
        trainerIdList: [],
        queryOrgType: '',
        groupType: '',
        groupTypeList: [],
        courseBrand: [],
        regionIds: [],
        startDate: '',
        endDate: ''
      },
      brandQuery: [],
      // 时间线的开始结束时间
      timeLines: [
        {
          time: dayjs()
            .add(2, "hour")
            .toString()
        },
        {
          time: dayjs()
            .add(5, "hour")
            .toString(),
          color: "#747e80"
        }
      ],
      currentTime: dayjs(),
      // 品牌类型
      courseBrandArr: this.enums['courseBrand'],
      cellWidth: 100, // 默认值100 在进行查询类型切换时进行更改值 月 20  周 15
      cellHeight: 38,
      titleHeight: 60,
      titleWidth: 250,
      // 时间间隔刻度 1440表示1天
      scale: 1440,
      // 设置开始和结束时间 开始时间的下标必须是0，结束是1
      times: [],
      queryType: 'day', // day 在进行查询类型切换时进行更改值 月 month 周 week
      cusTimes: [],
      datasB: [],
      // 组织类型
      neworgType: [],
      companyList: [],
      trainerList: [],
      typeArr: this.enums['orgType'], // 所属分类
      select2: [],
      select1: this.enums['catalogidList1'],
      allteamcatalog: this.enums['catalogidList2'],
      dataKey: "id",
      scaleList: scaleList,
      scrollToTime: dayjs()
        .add(1, "day")
        .toString(),
      scrollToPostion: { x: 10000, y: 10000 },
      hideHeader: false,
      moreList: false,
      isShow: false,
      hideSecondGantt: false,
      showValue: '',
      showVehicleClassList: [],
      // 团队分类
      defaultProps: {
        children: 'children',
        label: 'treamCnName'
      },
      queryTreeUrl: '/rm/rpc/treamClassTree/list',
      // 等待转圈
      dataListLoading: false,
      loading: false,
      isShowTrainer: false,
      trainerShowFlg: false,
      arrayKeys: ["gtArray", "error"],
      scrollToY: 0,
      positionB: {},
      positionA: {},
      holidayList: [],
      companyLoading: false,
      companyOptions: [],
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.dataForm.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.dataForm.startDate;
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      },
    };
  },
  watch: {
    colNum: "updateData",
    scrollToY (val) {
      this.positionA = { x: val };
    }
  },
  // 离开页面时
  beforeRouteLeave(to, from, next){
    this.$refs.gantChild.saveData()
			next()
  },
  mounted () {
    this.neworgType = JSON.parse(JSON.stringify(this.typeArr))
    if (this.neworgType.length === 6) {
      this.neworgType.splice(3, 2)
      // this.neworgType.splice(4, 1)
    }
    this.defaultDateS(); //默认查询时间值
    this.getDataList();
  },
  methods: {
    DateAdd (number, date) {
      let subDate = new Date()
      subDate.setMonth(date.getMonth() + number);
      return subDate;
    },
    defaultDateS () {
      //获取新的时间(2020.1.6）
      let startDate = new Date()
      let endDate = this.DateAdd(2, startDate) //当前日期加2个月后的日期
      let startYear = startDate.getFullYear().toString()   //'2020'
      let endYear = endDate.getFullYear().toString()   //'2020'
      //获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
      let startMonth = startDate.getMonth() + 1 < 10 ? '0' + (startDate.getMonth() + 1).toString() : (startDate.getMonth() + 1).toString()  //'01'
      let endMonth = endDate.getMonth() + 1 < 10 ? '0' + (endDate.getMonth() + 1).toString() : (endDate.getMonth() + 1).toString()  //'01'
      //字符串拼接，开始时间，结束时间
      let beg = ''
      let end = ''
      var lastDay = new Date(endYear, endMonth, 0).getDate() //获取月份的最后一天
      beg = startYear + '-' + startMonth + '-01'    //当年第一天'2020-01-01'
      end = endYear + '-' + endMonth + '-' + lastDay + ' ' + '23' + ':' + '59' + ':' + '59'
      //将值设置给插件绑定的数据
      this.dataForm.startDate = beg
      this.dataForm.endDate = end
    },
    queryDay () {
      let dayLable = document.getElementById('dayLable')
      let weekLable = document.getElementById('weekLable')
      let monthLable = document.getElementById('monthLable')
      dayLable.style.color = "black"
      weekLable.style.color = "blue"
      monthLable.style.color = "blue"
      this.queryType = 'day'
      this.cellWidth = 100
      this.getDataList()
    },
    queryWeek () {
      let dayLable = document.getElementById('dayLable')
      let weekLable = document.getElementById('weekLable')
      let monthLable = document.getElementById('monthLable')
      dayLable.style.color = "blue"
      weekLable.style.color = "black"
      monthLable.style.color = "blue"
      this.queryType = 'week'
      this.cellWidth = 15
      this.getDataList()
    },
    queryMonth () {
      let dayLable = document.getElementById('dayLable')
      let weekLable = document.getElementById('weekLable')
      let monthLable = document.getElementById('monthLable')
      dayLable.style.color = "blue"
      weekLable.style.color = "blue"
      monthLable.style.color = "black"
      this.queryType = 'month'
      this.cellWidth = 10
      this.getDataList()
    },
    // format日期
    dateFormat (date) {
      /* eslint-disable */
      // debugger
      if (date !== undefined) {
        date = typeof date === 'string' ? new Date(date.replace(/\-/g, '/')) : date
        var yy = date.getFullYear();      //年
        var mm = date.getMonth() + 1;     //月
        var dd = date.getDate();          //日
        var hh = date.getHours();         //时
        var ii = date.getMinutes();       //分
        var ss = date.getSeconds();       //秒
        var clock = yy + "/";
        if (mm < 10) clock += "0";
        clock += mm + "/";
        if (dd < 10) clock += "0";
        clock += dd + " ";
        if (hh < 10) clock += "0";
        clock += hh + ":";
        if (ii < 10) clock += '0';
        clock += ii + ":";
        if (ss < 10) clock += '0';
        clock += ss;
        return clock
        // return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
      } else {
        return ''
      }
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      if (this.brandQuery != null || this.brandQuery !== '') {
        this.dataForm.courseBrand = this.brandQuery + ''
      }
      this.$request.post(
        '/learning/offeringCalendar/getTrainerCalendarList',
        {
          order: this.order,
          orderField: this.orderField,
          ...this.dataForm
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        let start = data.data.minX
        let end = data.data.maxX
        this.holidayList = data.data.holidayList
        let resultList = data.data.calendarList
        this.times = []
        if (this.queryType == 'month') {
          start = getFirstDay(getDate(start))
          end = getLastDay(getDate(end))
          this.times.push(start, end)
        } else if (this.queryType == 'week') {
          start = GetMonday(getDate(start))
          end = GetSunday(getDate(end))
          this.times.push(start, end)
        } else {
          this.times.push(start, end)
        }
        for (let i = 0; i < resultList.length; i++) {
          for (let j = 0; j < resultList[i].gtArray.length; j++) {
            resultList[i].gtArray[j].start = this.dateFormat(resultList[i].gtArray[j].start)
            resultList[i].gtArray[j].end = this.dateFormat(resultList[i].gtArray[j].end)
            resultList[i].gtArray[j].startShort = this.dateFormat(resultList[i].gtArray[j].startShort)
            resultList[i].gtArray[j].endShort = this.dateFormat(resultList[i].gtArray[j].endShort)
          }
        }
        this.datasB = resultList;
        console.log(resultList)
        console.log(this.times)
        this.$refs.gantChild.dateDiff(this.times[0],this.times[1]);
      }).catch(() => {
        this.dataListLoading = false
        console.log("出错了！！！")
      })
    },// 重置
    again () {
      this.brandQuery = ''
      this.$refs.classRef.resetChecked()
      this.trainerList = []
      this.dataForm = {
        trainerName: '',
        personnelType: '',
        groupType: '',
        groupTypeList: [],
        courseBrand: [],
        regionIds: [],
        "startDate": '',
        "endDate": ''
      }
      this.defaultDateS()
      this.loading = false
      this.select2 = []
      try {
        this.$refs.offeringCoursedlist.toggleSelection()
      } catch (e) {

      }
      this.getDataList()
    },
    updateTimeLines (timeA, timeB) {
      this.timeLines = [
        {
          time: timeA
        },
        {
          time: timeB,
          color: "#747e80"
        }
      ];
    },
    scrollLeftA (val) {
      this.positionB = { x: val };
    },
    scrollLeftB (val) {
      this.positionA = { x: val };
    },
    // 批量导出
    exportHandle () {
      // download 参数 url, params, 报表名
      this.$request.download('/learning/offeringCalendar/exportTrainer', this.$t('培训师日历查看'),
        {
          ...this.dataForm,
          page: this.page,
          limit: this.limit
        }
      )
    },
    exportinfo () {
      // download 参数 url, params, 报表名
      this.$request.download('/learning/offeringCalendar/exportTrainerDetail', this.$t('培训师日历明细查看'),
        {
          ...this.dataForm,
          page: this.page,
          limit: this.limit
        }
      )
    },
    reportQuery () {
      console.log('reportQuery')
    },
    // 展开更多
    toggle (data) {
      this.isShow = data
    },
    trainerShow () {
      this.trainerShowFlg = true
    },
    trainerLeave () {
      this.trainerShowFlg = false
    },
    showTrainerDlg () {
      this.isShowTrainer = true
      this.$nextTick(() => {
        this.$refs.trainerInfoRef && this.$refs.trainerInfoRef.initMethods()
      })
    },
    trainerSeleteName () {
      this.dataForm.trainerName = ''
      this.dataForm.trainerIdList = []
      this.trainerList = []
      this.trainerShowFlg = false
    },
    handleClose () {
      this.isShowTrainer = false
    },
    closeSuboTrainerDlg () {
      this.isShowTrainer = false
    },
    // 培训师选择完成
    onOk: function (data) {
      let rowData = data
      let trainerName = ''
      let trainerId = []
      for (var i = 0; i < rowData.length; i++) {
        trainerName = trainerName + rowData[i].trainerName + ','
        trainerId.push(rowData[i].trainerId)
      }
      trainerName = trainerName.substr(0, trainerName.length - 1)
      this.dataForm.trainerIdList = trainerId
      this.dataForm.trainerName = trainerName
      this.isShowTrainer = false
      this.trainerList = data
    },
    // 团队分类
    getSelectList (args) {
      let tramClass = []
      if (args && args !== '' && args.length > 0) {
        args.forEach(function (item) {
          tramClass.push(item.id)
        })
      }
      this.dataForm.groupTypeList = tramClass
    },
    // 子页面重置按钮触发
    clearTreeInfo (listName) {
      if (listName === 'trainser') {
        this.dataForm.groupTypeList = []
      }
    },// 组织类型
    add (value) {
      if (value === '' && value === undefined && value === null) {
        this.companyList = []
      } else {
        this.queryCompany(value)
      }
    },// 查询公司下拉选
    queryCompany (val) {
      // 获取公司下拉框数据
      if (val !== '' && val !== undefined && val !== null) {
        this.$request.get(`/rm/company/info`, { 'orgTypeList': val }).then((data) => {
          let arr = []
          data.forEach(function (item) {
            let param = { value: item.orgId, label: item.nameCn }
            arr.push(param)
          })
          this.companyList = arr
        })
      } else {
        this.companyList = []
      }
    },
  }
};
</script>
<style lang="scss" scoped>
@import "../../../css/pkg-styles.css";
#app >>> .gantt-leftbar-wrapper {
  /* height: auto !important; */
  /* overflow: visible; */
}
#app >>> .gantt-body {
  position: relative;
  /* overflow-y: scroll; */
}
#app >>> .gantt-block-top-space {
  height: 0px !important;
}
#app >>> .gantt-scroll-y {
  /* display: none; */
}
/* 节假日的样式 */
#app >>> .gantt-timeline-holidayBlock {
  background-image: linear-gradient(
    to top,
    rgb(153, 152, 152),
    rgb(160, 157, 157)
  );
  /* background: #ddd; */
  width: 20px;
  height: 60px;
  border-right: 1px solid rgb(245, 248, 248);
}
#app >>> .gantt-timeline-block {
  /*background-image: linear-gradient(*/
  /*to top,*/
  /*rgb(230, 224, 224),*/
  /*rgb(165, 161, 161)*/
  /*);*/
  /* background: #ddd; */
  background: rgb(221, 218, 210);
  width: 20px;
  height: 60px;
  border-right: 1px solid rgb(245, 248, 248);
}
#app >>> .gantt-timeline-weekBlock {
  /*background-image: linear-gradient(*/
  /*to top,*/
  /*rgb(230, 224, 224),*/
  /*rgb(165, 161, 161)*/
  /*);*/
  background: rgb(221, 218, 210);
  border-right: 1px solid rgb(245, 248, 248);
  /* background: #ddd; */
}

/* 节假日的样式 */
#app >>> .gantt-timeline-holidayBlock {
  background-image: linear-gradient(
    to top,
    rgb(153, 152, 152),
    rgb(160, 157, 157)
  );
  /* background: #ddd; */
  width: 20px;
  height: 60px;
  border-right: 1px solid rgb(245, 248, 248);
}

/* 工作日的样式 */
#app >>> .gantt-timeline-block {
  /* background-image: linear-gradient(
    to top,
    rgb(230, 224, 224),
    rgb(165, 161, 161)
  ); */
  background: rgb(221, 218, 210);
  width: 20px;
  height: 60px;
  border-right: 1px solid rgb(245, 248, 248);
}

#app >>> .gantt-timeline-scale {
  border-top: 1px solid rgb(245, 248, 248);
}
#app >>> #scroll-gantt-table {
}
/* 页面最下面的颜色分类样式 */
.class1 {
  margin-left: 5px;
  width: 40px;
  height: 40px;
  border: 1px solid #ccc;
  background: rgb(173, 185, 206);
}
.class2 {
  margin-left: 5px;
  width: 20%;
  height: 20%;
  border: 1px solid #ccc;
  background: rgb(254, 203, 0);
}
.class3 {
  margin-left: 5px;
  width: 20%;
  height: 20%;
  border: 1px solid #ccc;
  background: rgb(201, 209, 222);
}
.class4 {
  margin-left: 5px;
  width: 20%;
  height: 20%;
  border: 1px solid #ccc;
  background: rgb(255, 245, 204);
}
.search-item {
  width: 94% !important;
  min-width: 290px;
}

</style>
<style lang="scss">
#mod-rm__trainerinformation {
  .module-company-select {
    .el-select {
      .el-input .el-input__inner{
        cursor: text !important;
      }
    }
  }
}
.search-item .el-form-item__content {
  margin-left: 96px !important;
}
</style>
